export enum AutoAssignmentType {
  Group = 'Group',
  Member = 'Member',
  MultiMember = 'MultiMember',
}
